/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingPaymentMethod } from './BillingPaymentMethod';
import {
    BillingPaymentMethodFromJSON,
    BillingPaymentMethodFromJSONTyped,
    BillingPaymentMethodToJSON,
    BillingPaymentMethodToJSONTyped,
} from './BillingPaymentMethod';

/**
 * 
 * @export
 * @interface CreatePaymentMethodResponse
 */
export interface CreatePaymentMethodResponse {
    /**
     * 
     * @type {BillingPaymentMethod}
     * @memberof CreatePaymentMethodResponse
     */
    data: BillingPaymentMethod;
}

/**
 * Check if a given object implements the CreatePaymentMethodResponse interface.
 */
export function instanceOfCreatePaymentMethodResponse(value: object): value is CreatePaymentMethodResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreatePaymentMethodResponseFromJSON(json: any): CreatePaymentMethodResponse {
    return CreatePaymentMethodResponseFromJSONTyped(json, false);
}

export function CreatePaymentMethodResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePaymentMethodResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': BillingPaymentMethodFromJSON(json['data']),
    };
}

  export function CreatePaymentMethodResponseToJSON(json: any): CreatePaymentMethodResponse {
      return CreatePaymentMethodResponseToJSONTyped(json, false);
  }

  export function CreatePaymentMethodResponseToJSONTyped(value?: CreatePaymentMethodResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BillingPaymentMethodToJSON(value['data']),
    };
}

